import React, { useState, useEffect } from 'react';
import { Table, Tag, Button,message, Space, Tooltip, Popconfirm } from 'antd';
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import ApiService from '../Components/apiService';
import { BASE_URL,DateFormat,DateTimeFormat } from '../Components/Constant';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const ClonedOrgsSection = ({ clonedOrgs: initialClonedOrgs = [] }) => {
  const navigate = useNavigate();
  const [clonedOrgs, setClonedOrgs] = useState([]);

  // Dummy data for testing
  useEffect(() => {
    console.log('initialClonedOrgs IN CLONED organisation:', initialClonedOrgs);
     setClonedOrgs(initialClonedOrgs || []);

  }, [initialClonedOrgs]);
  
  const handleDelete = async (record) => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/super_admin/delete_org/${record._id}`,
        { 'Content-Type': 'application/json' },
        'POST'
      );
  
      await apiService.makeCall();
  
      // Refresh and update UI
      setClonedOrgs(prev => prev.filter(org => org._id !== record._id));
      message.success(`Organization "${record.name}" deleted successfully.`);
    } catch (error) {
      console.error("Error deleting organization:", error);
      message.error("Failed to delete organization.");
    }
  };
  

  const handleViewClick = (record) => {
    console.log('Viewing cloned org:', record);
    // console.log('Viewing cloned org:HSON ' + JSON.stringify(record, null, 2));
    // console.log('Viewing cloned org:+ ' + record);
    console.log('cookiesss for superadmin:: ',Cookies.get("SuperAdminToken"))
    navigate(`/Admin/organization/${record._id}`);
    // navigate(`/Admin`);
  }
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'default';
        if (status === 'Active') color = 'green';
        else if (status === 'In Progress') color = 'blue';
        else if (status === 'Failed') color = 'red';
        return <Tag color={color}>{status}</Tag>;
      }
    },
    // {
    //   title: 'Last Refreshed At',
    //   dataIndex: 'last_refreshed_at',
    //   key: 'last_refreshed_at',
    //   render: (timestamp) => {
    //     if (!timestamp) return 'N/A';

    //     const date = new Date(timestamp);
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = String(date.getMonth() + 1).padStart(2, '0');
    //     const year = date.getFullYear();

    //     return `${day}/${month}/${year}`;
    //   }
    // },
    {
  title: 'Last Refreshed At',
  dataIndex: 'last_refreshed_at',
  key: 'last_refreshed_at',
  render: (timestamp) => {
    if (!timestamp) return '';

    const formattedDate = dayjs(timestamp).format('DD/MM/YYYY');
    const relative = dayjs(timestamp).fromNow();

    return (
      <div style={{ lineHeight: '1.2' }}>
        <div style={{ fontWeight: 500 }}>
          {formattedDate}
        </div>
        <div style={{ fontSize: '9px', color: '#888' }}>
          {relative}
        </div>
      </div>
    );
  }
},
        {
      title: 'Sandbox Type',
      dataIndex: 'cloneType',
      key: 'cloneType'
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EyeOutlined />}
            size="small"
            onClick={() => handleViewClick(record)}
          >
          </Button>

          <Tooltip title="Delete">
            <Popconfirm
              title="Are you sure you want to delete this organization?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => handleDelete(record)}
            >
              <DeleteOutlined
                style={{
                  color: 'red',
                  marginRight: 5,
                  fontSize: '16px',
                  cursor: 'pointer'
                }}
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      )
    }
    
  ];

  return (
    <Table
      columns={columns}
      dataSource={clonedOrgs}
      rowKey="id"
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        // showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      }}
    />
  );
};

export default ClonedOrgsSection;